import { $, $$ } from '../helpers/selectors';

const SELECTOR = '[download], [data-download]';

class Showcase {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    const downloadLinks = $$(SELECTOR);

    downloadLinks.forEach(item => {
      if (! item.classList.contains('report-download-btn')) {
        item.addEventListener('click', e => {
          const assetLink = e.target.href;
          const assetType = assetLink.substring(assetLink.lastIndexOf('.') + 1, assetLink.length) || assetLink;
          let contentTitle = '';

          if (e.target.parentNode.classList.contains('card')) {
            const targetElem = e.target.parentNode;
            contentTitle = targetElem.querySelector('.card__title-content').textContent.trim();
          } else {
            contentTitle = e.target.textContent.trim();
          }

          window.dataLayer.push({
            event: 'download',
            eventType: 'asset download click',
            assetType,
            contentTitle,
          });
        });
      }
    });
  }
}

export default Showcase;
